import React from 'react';
import { Collapse } from 'antd';

const WlsExcludedRows = (props) => {
    const { Panel } = Collapse;
    const excluded = props.getAnalysisRes?.weighted_scatterplot?.wls_excluded;

    if (!excluded || excluded.count === 0) return null;

    const rowsMap = excluded.rows.map((item, idx) => (
        <tr key={idx}>
            <td>{item[0]}</td>
            <td>{item[1]}</td>
        </tr>
    ));

    return (
        <Collapse bordered={false} defaultActiveKey={[1]}>
            <Panel
                key={1}
                header={`Excluded Observations (${excluded.x_display_name} \u2264 0) - ${excluded.count} rows`}
                id="id-wls-excluded"
            >
                <div className="table-box-fullproject">
                    <table className="table-regression">
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th>{excluded.x_display_name}</th>
                            </tr>
                        </thead>
                        <tbody>{rowsMap}</tbody>
                    </table>
                </div>
            </Panel>
        </Collapse>
    );
};

export default React.memo(WlsExcludedRows);
